import axios from "axios";
import store from '@/store'
import Lockr from "lockr";
import jsrsasign from 'jsrsasign';
import {removeAuth} from '@/utils/auth'
import router from '@/router'
import cache from '@/utils/cache'
import { Message, MessageBox } from 'element-ui';

//配置
import xconfig from '@/config'

//解码
let jGlobalSetting=''
if(process.env.NODE_ENV == 'production' && GlobalSetting){
    jGlobalSetting=JSON.parse(window.atob(GlobalSetting))
}

//多语种
import i18n from '@/utils/i18n'
window.BASE_URL_SH = (process.env.NODE_ENV == 'development')?process.env.BASE_SH_API:jGlobalSetting.BASE_SH_API

axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8'

const service = axios.create({
    // baseURL: window.BASE_URL, // api 的 base_url
    baseURL: window.BASE_URL_SH,
    timeout: 600000, // 请求超时时间
    responseType:'json',
})

//请求拦截
service.interceptors.request.use(
    config=>{
        let codesk=config.url.split('/')
        if(!codesk || codesk.length<=0){
            return false
        }
        let codesk1=codesk[2]
        let fiess=codesk[3]
        let data=config.data

        if(fiess!='GetPublicKey' && codesk1!='LogModule'){
            //默认参数
            data.AppEstateId=xconfig.AppEstateId
            data.AppMerchantId=(process.env.NODE_ENV == 'development')?process.env.BASE_AppMerchantId:jGlobalSetting.BASE_AppMerchantId
            // data.DeviceInfo=navigator.userAgent
            data.ClientType=xconfig.ClientType
            data.Language=store.state.app.lang?cache.getLanuageId(store.state.app.lang):cache.getLanuageId(xconfig.Language)
            // data.KeyId=''

            config.data=data

            //处理参数
            let sign=signApi(data)
            if(sign && sign!=-1){
                if(config.method=='get'){
                    config.params.sign=sign
                }else{
                    config.data.sign=sign
                }

                return config
            }else{
                console.warn('签名错误跳转')

                source.cancel()
                Message({
                    type:'error',
                    message:i18n.$t('errorRequest')
                })
                return false
            }
        }else{
            //默认参数
            data.IsLogged=0
            data.KeyId=''
            // data.UserId=''
            data.ClientType=xconfig.ClientType
            data.Language=store.state.app.lang?cache.getLanuageId(store.state.app.lang):cache.getLanuageId(xconfig.Language)

            return config
        }
    },
    error=>{
        console.warn('请求拦截错误',error)
    }
)

//返回拦截
service.interceptors.response.use(
    response=>{
        console.log('response',response)
        const res = response.data
        let fullPath=window.location.href
        fullPath=encodeURI(fullPath)
        let codesk=response.config.url.split('/')
        if(!codesk || codesk.length<=0){
            return false
        }
        let codesk1=codesk[2]
        let fiess=codesk[3]

        //判断
        switch(res.Code){
            //系统异常
            case 1002:
            case 20007:
            case 20009:
                console.warn('系统异常')
                Message({
                    type:'error',
                    message:i18n.t('errorRequest')
                })
                source.cancel()
                break
            //账号已在其它设备登入
            case 1004:
                console.warn('账号已在其它设备登入')
                Message({
                    type:'error',
                    message:StateList.StateMsg?StateList.StateMsg:i18n.t('errorRequest')
                })
                source.cancel()
                break
            //没有该功能的权限
            case 1005:
                console.warn('没有该功能的权限')
                Message({
                    type:'error',
                    message:StateList.StateMsg?StateList.StateMsg:i18n.t('errorRequest')
                })
                source.cancel()
                break
            //用户不存在或已失效
            case 1006:
                console.warn('用户不存在或已失效')
                MessageBox({
                    message:i18n.t('accoundInvalid'),
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    confirmButtonText:i18n.t('confirm'),
                    callback:action=>{
                        removeAuth()
                        router.push({path:'/login'})
                    }
                })
                source.cancel()
                break
            //数据异常
            case 2001:
                console.warn('数据异常')
                Message({
                    type:'error',
                    message:i18n.t('errorRequest')
                })
                return Promise.reject(res)
                break
            //未找到
            case 2002:
                console.warn('未找到数据')
                Message({
                    type:'error',
                    message:i18n.t('errorRequest')
                })
                return Promise.reject(res)
                break
            //正常
            case 1001:
            case 2003:
            case 0:
                //验证返回数据
                let ResultData=res.ResultData
                if(ResultData.hasOwnProperty('ClientPrivateKey')){
                    return res.ResultData
                }else{
                    return res.ResultData
                }
                break;
            default:
                console.warn('res.Code不存在')
                Message({
                    type:'error',
                    message:StateList.StateMsg?StateList.StateMsg:i18n.t('errorRequest')
                })
                return Promise.reject(res)
                break
        }
    },
    error => {
        console.warn('返回拦截错误',error)
        let errormessage=i18n.t('errorRequest')
        if (error.response) {
            const response = error.response
            if (response.status == 500) {
                errormessage=i18n.t('errorRequest')
            } else if (response.data && response.data.msg) {
                errormessage=response.data.msg
            }
        }

        if(reqUrl!='OperateInboxMsg'){
            Message({
                type:'error',
                message:errormessage
            })
        }

        return Promise.reject(error)
    }
)

function myIsNaN(value) {
    return typeof value === 'number' && !isNaN(value);
}

//处理参数
function decodingParameter(parameter,istyui=false) {
    let sortData = {}
    //排序
    Object.keys(parameter).sort(function(a,b){
        if(myIsNaN(a) && myIsNaN(b)){
            return a>b?1:a<b?-1:0;
        }else if(myIsNaN(a) && !myIsNaN(b)){
            return 1;
        }else if(!myIsNaN(a) && myIsNaN(b)){
            return -1;
        }else{
            let x=a.toLowerCase()
            let y=b.toLowerCase()
            if(x>y){
                return 1;
            }else if(x<y){
                return -1;
            }else{
                return a>b?1:a<b?-1:0
            }
        }
    }).map(key => {
        sortData[key] = parameter[key]
    })

    //过滤
    let parameterString = ''
    for (let i in sortData) {
        if (sortData[i] === null || sortData[i] === '' || typeof sortData[i] == 'undefined' || i.toLowerCase() == 'sign' || i.toLowerCase() == 'sign_type') {
            continue;
        } else {
            //判断
            if(istyui && i=='ResultData'){
                sortData[i]=JSON.stringify(sortData[i])
            }
            // if(istyui && i=='ResultData'){
            //     sortData[i]=decodingParameter(sortData[i])
            // }
            parameterString += (i + "=\"" + rfc3986EncodeURIComponent(sortData[i]) + "\"&")
        }
    }

    //去掉最后参数
    if (parameterString) {
        parameterString = parameterString.substring(0, parameterString.length - 1)
    }

    return parameterString
}

function rfc3986EncodeURIComponent (str) {
    // return encodeURIComponent(str).replace(/[!'*]/g, escape);
    return encodeURIComponent(str).replace(/['*]/g, escape);
}

//签名
function signApi(parameter,type){
    let src=decodingParameter(parameter)
    let priK=Lockr.get('mtrshop_client_pri')
    if(type=='log'){
        priK=Lockr.get('mtrshop_log_client_pri')
    }
    if(priK){
        priK=("-----BEGIN RSA PRIVATE KEY-----\n"+priK+"\n-----END RSA PRIVATE KEY-----")
        let rsa = new jsrsasign.RSAKey()
        rsa = jsrsasign.KEYUTIL.getKey(priK)
        let sig = new jsrsasign.KJUR.crypto.Signature({ alg: 'SHA256withRSA' });
        sig.init(rsa);
        sig.updateString(src)
        let sign = jsrsasign.hextob64(sig.sign())
        return sign
    }else{
        console.warn('ClientPrivateKey不存在')
        return -1
    }
}

//验证签名
function checkSign(reqData,type){
    // return true
    let newreqData=Object.assign({}, reqData)
    let sign=''
    if(!newreqData || !newreqData.sign){
        return true
    }else{
        sign=newreqData.sign
        delete reqData.sign
    }

    let src=decodingParameter(reqData,true)
    let publicKey=Lockr.get('mtrshop_server_pri')
    if(type=='LogModule'){
        publicKey=Lockr.get('mtrshop_log_server_pri')
    }
    if(publicKey){
        publicKey=("-----BEGIN PUBLIC KEY-----\n"+publicKey+"\n-----END PUBLIC KEY-----")
        let signature = new jsrsasign.KJUR.crypto.Signature({'alg': 'SHA256withRSA', 'prvkeypem': publicKey});
        signature.updateString(src); // 传入待签明文
        return signature.verify(jsrsasign.b64tohex(sign))
    }else{
        console.warn('server_pri不存在')
        return false
    }
}

//判断是否是对象
function isObjectNum(str) {
    return Object.prototype.toString.call(obj) === '[object Object]'
}

export default service



// WEBPACK FOOTER //
// ./src/api/indexSH.js